export const badgeIcons: { [key: string]: string } = {
  TEACHER_MODE: 'apple.svg',
};
